import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Ai_Tools_Covered.css";
import { useNavigate } from "react-router-dom";

const toolsData = [
  {
    title: "Marketing Management",
    items: [
      "ChatGPT & Jasper AI (AI-powered content creation)",
      "HubSpot AI (Marketing automation & CRM)",
      "Persado (AI-driven marketing messaging)",
      "Phrasee (AI-generated ad copy & email subject lines)",
      "Canva AI (AI-powered design assistance)",
    ],
  },
  {
    title: "Human Resource Management",
    items: [
      "Hiretual & Eightfold AI (AI-powered talent acquisition)",
      "Workday AI (HR analytics & workforce planning)",
      "Pymetrics (AI-driven recruitment assessments)",
      "Turing (AI for remote workforce hiring)",
    ],
  },
  {
    title: "Finance Management",
    items: [
      "Kavout (AI-driven investment research)",
      "AlphaSense (AI-powered financial market insights)",
      "ZestFinance (AI for credit underwriting)",
      "Bloomberg Terminal AI (Market analysis)",
    ],
  },
  {
    title: "IT Management",
    items: [
      "ServiceNow AI (IT service management automation)",
      "Jira AI (IT project & issue tracking)",
      "Microsoft Copilot (AI for IT task automation)",
    ],
  },
  {
    title: "Project Management",
    items: [
      "Asana AI & Trello AI (AI-powered task automation)",
      "Monday.com AI (Project workflow automation)",
      "ClickUp AI (AI-driven project insights)",
      "Wrike AI (Resource allocation optimization)",
      "nTask AI (AI-enhanced project planning)",
    ],
  },
  {
    title: "Operations Management",
    items: [
      "UiPath & Automation Anywhere (AI-powered process automation)",
      "Anaplan (AI for supply chain & operations planning)",
      "Llamasoft AI (AI-driven logistics optimization)",
      "Celonis (AI for process mining & optimization)",
      "IBM Watson Supply Chain (Predictive analytics)",
    ],
  },
  {
    title: "Hospital and Healthcare Management",
    items: [
      "Watson Health (AI-powered healthcare analytics)",
      "DeepMind Health (AI for predictive diagnostics)",
      "Olive AI (AI automation for hospital management)",
      "Qventus (AI-driven hospital workflow optimization)",
      "Zebra Medical Vision (AI for medical imaging analysis)",
    ],
  },
  {
    title: "International Business Management",
    items: [
      "Crimson Hexagon AI (AI-powered global market analysis)",
      "KAI AI (Conversational AI for international business)",
      "Tableau AI (Data-driven international market insights)",
      "Luminance AI (AI for international contract management)",
      "Google Market Finder AI (International business expansion insights)",
    ],
  },
  {
    title: "FinTech Management",
    items: [
      "Tegra118 AI (AI-powered wealth management)",
      "ZestFinance (AI in credit risk assessment)",
      "Kabbage AI (AI-driven small business lending)",
      "Darktrace AI (AI-driven fraud detection)",
      "Plaid AI (FinTech AI for financial transactions)",
    ],
  },
  {
    title: "Business Analytics Management",
    items: [
      "Tableau AI & Power BI AI (AI-driven data visualization)",
      "RapidMiner (AI-based data science platform)",
      "DataRobot (Automated machine learning for analytics)",
      "H2O.ai (AI-powered predictive analytics)",
      "Google Vertex AI (Business intelligence with AI)",
    ],
  },
  {
    title: "Artificial Intelligence and Machine Learning",
    items: [
      "TensorFlow & PyTorch (AI & ML model development)",
      "Google AutoML (Automated machine learning)",
      "IBM Watson AI (AI-powered business solutions)",
      "AWS AI Services (Comprehensive AI tools)",
      "Microsoft Azure ML (AI & ML model training)",
    ],
  },
  {
    title: "Logistics, Materials, and Supply Chain Management",
    items: [
      "Llamasoft AI (AI-driven logistics decision-making)",
      "FourKites AI (Real-time supply chain visibility)",
      "Project44 AI (AI-powered freight management)",
      "Blume Global AI (AI in supply chain automation)",
    ],
  },
  {
    title: "Blockchain Management",
    items: [
      "IBM Blockchain AI (AI for smart contract management)",
      "Hyperledger Fabric (Enterprise blockchain AI solutions)",
      "Ethereum AI (AI-powered decentralized applications)",
      "Chainalysis AI (AI in blockchain security & compliance)",
      "Consensys AI (AI-driven blockchain finance tools)",
    ],
  },
  {
    title: "Digital Marketing Management",
    items: [
      "SurferSEO AI & Clearscope (AI-driven SEO optimization)",
      "Adzooma AI (AI-powered digital ad management)",
      "ChatGPT & Jasper AI (AI-powered content generation)",
      "Albert AI (AI-driven digital marketing automation)",
      "Canva AI (AI-powered creative design)",
    ],
  },
  {
    title: "AgriBusiness Management",
    items: [
      "Taranis AI (AI for precision farming)",
      "Prospera AI (AI-powered farm management)",
      "aWhere AI (AI for weather-based agribusiness decisions)",
      "AgNext AI (AI-driven supply chain for agriculture)",
    ],
  },
];

const Ai_Tools_Covered = () => {
  const navigate = useNavigate();
  return (
    <section className="ai_tool">
      <div className="container">
        <div className="widget-title">
          <h3>AI Tools Covered</h3>
        </div>

        <Swiper
          modules={[Pagination]}
          spaceBetween={10}
          slidesPerView={4}
          breakpoints={{
            320: { slidesPerView: 1.2 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
          pagination={{
            clickable: true,
            dynamicMainBullets: 1,
          }}
          // autoplay={{ delay:3500, disableOnInteraction: true }}
          loop
          className="pb-4"
        >
          {toolsData.map((category, index) => (
            <SwiperSlide key={index}>
              <div className="tool_box">
                <h4>{category.title}</h4>
                <ul className="tool_list">
                  {category.items.map((item, i) => {
                    const [name, desc] = item.split(" (");
                    const cleanDesc = desc ? `(${desc}` : "";
                    return (
                      <li key={i}>
                        <strong>{name}</strong> {cleanDesc}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="text-center">
          <button
            className="talk_btn"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" }); 
              navigate("/"); 
            }}
          >
            Talk to Experts
          </button>
        </div>
      </div>
    </section>
  );
};

export default Ai_Tools_Covered;
